import styled from "styled-components";
import { CircleButton, Button } from "_c/button";
import { Link } from "react-router-dom";
import BaseAvatar from "_c/Avatar";

export const AvatarWrap = styled.div``;
export const Rate = styled.span`
  border-radius: 50%;
  width: 37px;
  height: 37px;
  background: var(--grad-primary-n);
  display: block;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: white;
  margin-top: 10px;
`;
export const Avatar = styled(BaseAvatar)`
  margin-top: 18px;
  @media (max-width: 575px) {
    margin-top: 0;
  }
`;
export const Sect = styled.div`
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  margin-left: 40px;
  @media (max-width: 575px) {
    margin-left: 0;
  }
`;
export const Name = styled(Link)`
  font-size: 16px;
  color: var(--font-color-emp);
  font-weight: 600;
`;
export const When = styled.p`
  margin-top: 2px;
  font-size: 13px;
  color: var(--font-color-accent);
  margin-bottom: 0;
`;
export const Quote = styled.p`
  font-weight: 500;
  margin-bottom: 18px;
  margin-top: 10px;
  max-width: 450px;
  font-size: 16px;
  word-wrap: break-word;
  width: 100%;
  color: var(--font-color-accent);
  @media (max-width: 1199px) {
    max-width: 400px;
  }
  @media (max-width: 767px) {
    max-width: 260px;
  }
  @media (max-width: 575px) {
    max-width: none;
  }
`;
export const ProviderLink = styled(Link)`
  border-bottom: 1px solid var(--font-color-main);
  color: var(--font-color-main);
  font-size: 14px;
  display: inline-block;
  margin-right: 7px;
  transition: all 0.25s ease;
  :focus,
  :hover {
    border-bottom-color: transparent;
    opacity: 0.7;
  }
`;
export const RespBtn = styled(Button).attrs({
  outline: true,
  small: true,
})`
  margin-right: 10px;
  @media (max-width: 575px) {
    margin: 0 5px;
  }
`;
export const Photo = styled.img`
  width: 100%;
  object-fit: cover;
  min-height: 100px;
  height: auto;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
`;
export const Figure = styled.figure`
  max-width: 100px;
  margin: 0;
  margin-right: 25px;
  margin-left: auto;
  padding-left: 25px;
  @media (max-width: 575px) {
    display: none;
  }
`;
export const MobileFigure = styled.figure`
  display: none;
  @media (max-width: 575px) {
    display: block;
    margin: 0;
    margin-top: 10px;
    margin-bottom: 20px;
  }
`;
export const ButtonSect = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 575px) {
    justify-content: center;
    flex-direction: column;
  }
`;
export const MetaButtonSect = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 575px) {
    margin-top: 15px;
  }
`;
export const Container = styled.div`
  margin-bottom: 10px;
  background: var(--bg-paper);
  position: relative;
  z-index: 3;
  border-radius: 7px;
  overflow: hidden;
  box-shadow: 0 7px 15px rgba(72, 69, 50, 0.15);
  @media (max-width: 575px) {
    margin: 0 auto;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;
export const InnerWrap = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 10px 15px 25px;
  @media (max-width: 575px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px;
    padding-top: 25px;
  }
`;
export const CameraBtn = styled(CircleButton)``;
export const ShareBtn = styled(CircleButton).attrs({
  light: true,
})`
  margin-left: 10px;
`;

export const Meta = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  > div:first-child {
    margin-left: 0;
  }
  @media (max-width: 575px) {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }
`;
export const OpenComments = styled.button`
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  color: white;
  width: 100%;
  background: var(--grad-primary-n);
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  padding: 9px 0;
  outline: none;
  :focus,
  :hover {
    background: var(--grad-primary-h);
  }
`;
export const AccentTopWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 575px) {
    flex-direction: column;
    justify-content: center;
  }
`;
export const AccentRole = styled.span`
  background: var(--grad-primary-n);
  color: white;
  font-size: 14px;
  border-radius: 24px;
  padding: 5px 10px;
  margin-left: 14px;
  font-weight: 500;
  @media (max-width: 575px) {
    margin-left: 0;
    margin-top: 10px;
  }
`;
export const RemoveCommentBtn = styled.button`
  box-shadow: none;
  border: none;
  color: var(--color-danger);
  font-weight: 500;
  font-size: 13px;
  text-align: left;
  outline: none;
  transition: opacity 0.25s ease;
  :focus,
  :hover {
    opacity: 0.65;
  }
`;
